// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"TermsAndConditions_swiper-slide-active__f9dIJ","container":"TermsAndConditions_container__DmYEY","wrapper":"TermsAndConditions_wrapper__Hy7mG"};